module.exports = __webpack_public_path__ + "static/pp_button-61f41a5e3049eb5d00e8a132a151fe0b.jpg";